import FadeInWrapper from "../../../components/common/fade-in-wrapper";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useRef } from "react";
import "swiper/swiper-bundle.css";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import { Swiper as SwiperType } from "swiper/types";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";

// Preload Images
import RibonIcon from "../friends/image/ribon.png";
import StoreIcon from "../friends/image/store.png";
import ChefIcon from "../friends/image/chef.png";
import CookIcon from "../friends/image/cook.png";
import PersonIcon from "../friends/image/person.png";

const reviews = [
  {
    src: "https://cdn-mahi.com/review3.png",
    alt: "review3",
    price: 7000,
    discountPrice: 3700,
  },
  {
    src: "https://cdn-mahi.com/review1.png",
    alt: "review1",
    price: 20000,
    discountPrice: 8900,
  },
  {
    src: "https://cdn-mahi.com/1750905351377-IMG_6469.jpeg",
    alt: "review0",
    price: 10000,
    discountPrice: 3900,
  },
  {
    src: "https://cdn-mahi.com/1755008789140-1000046936.jpg",
    alt: "review1",
    price: 22000,
    discountPrice: 9700,
  },
  {
    src: "https://cdn-mahi.com/1755082954288-1000015388.jpg",
    alt: "review1",
    price: 22000,
    discountPrice: 13200,
  },
  {
    src: "https://cdn-mahi.com/review2.png",
    alt: "review2",
    price: 10000,
    discountPrice: 4000,
  },
  {
    src: "https://cdn-mahi.com/1754994971653-image.jpg",
    alt: "review2",
    price: 25000,
    discountPrice: 13750,
  },
  {
    src: "https://cdn-mahi.com/review4.png",
    alt: "review4",
    price: 15000,
    discountPrice: 6900,
  },
  {
    src: "https://cdn-mahi.com/review5.png",
    alt: "review5",
    price: 20000,
    discountPrice: 8900,
  },
  {
    src: "https://cdn-mahi.com/review6.png",
    alt: "review6",
    price: 10000,
    discountPrice: 6200,
  },
];

const OnboardingPrice = () => {
  const navigate = useNavigate();
  const swiperRef = useRef<SwiperType | null>(null);

  // Preload Images for Next Page
  useEffect(() => {
    const imagesToPreload = [
      RibonIcon,
      StoreIcon,
      ChefIcon,
      CookIcon,
      PersonIcon,
    ];

    imagesToPreload.forEach((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;
    });
  }, []);

  return (
    <div className="h-full bg-white min-h-screen relative pb-44">
      <>
        <FadeInWrapper className="flex flex-col h-full pt-4 px-4">
          {/* 타이틀 */}
          <div className="flex items-start mt-4 mb-4">
            <div
              className="w-2 h-full bg-blue-500 rounded-lg mr-4"
              style={{ minHeight: "100px" }}
            />
            <h1 className="text-5xl text-black font-[900] leading-snug">
              얼마나 <br />
              저렴한가요?
            </h1>
          </div>
        </FadeInWrapper>

        {/* 리뷰 스와이프 영역 */}
        <FadeInWrapper className="flex flex-col items-center mt-4 gap-4">
          <div className="text-center text-gray-700 mb-4">
            실제 고객들이 경험한 <br />
            마감할인 가격을 확인해보세요!
          </div>

          <div className="w-full">
            <Swiper
              spaceBetween={20}
              initialSlide={0}
              style={{
                paddingLeft: "3rem",
                paddingRight: "3rem",
              }}
              centeredSlides={true}
              onSwiper={(swiper: SwiperType) => (swiperRef.current = swiper)}
            >
              {reviews.map((review, index) => (
                <SwiperSlide key={`review-${index}`} style={{ width: "100%" }}>
                  <div className="flex flex-col items-center border-2 w-full h-64 border-black rounded-xl shadow-lg bg-white">
                    {/* 리뷰 이미지 */}
                    <div className="w-full h-full rounded-lg overflow-hidden">
                      <ResponsiveCDNImage
                        src={review.src}
                        alt={review.alt}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  {/* 가격 정보 */}
                  <div className="text-center mt-2">
                    <div className="flex flex-col items-center mb-1">
                      <span className="text-lg text-gray-500 line-through">
                        {review.price.toLocaleString()}원
                      </span>
                    </div>
                    <div className="text-2xl font-bold text-[#1562fc]">
                      {review.discountPrice.toLocaleString()}원
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* 스와이프 네비게이션 */}
            <div className="flex items-center justify-center gap-4 mt-4">
              <button
                onClick={() => swiperRef.current?.slidePrev()}
                className="p-2 bg-gray-200 rounded-full text-gray-600 hover:bg-gray-300 transition-colors"
              >
                <HiArrowLeft className="w-5 h-5" />
              </button>
              <span className="text-sm text-gray-500">
                스와이프하여 더 많은 리뷰 보기
              </span>
              <button
                onClick={() => swiperRef.current?.slideNext()}
                className="p-2 bg-gray-200 rounded-full text-gray-600 hover:bg-gray-300 transition-colors"
              >
                <HiArrowRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </FadeInWrapper>

        {/* 버튼 영역 */}
        <FadeInWrapper className="px-5 py-4 w-full fixed bottom-0 left-0">
          <Button onClick={() => navigate("/onboarding/friends")} text="다음" />
        </FadeInWrapper>
      </>
    </div>
  );
};

export default OnboardingPrice;

const Button = ({ onClick, text }: { onClick: () => void; text: string }) => {
  return (
    <FadeInWrapper className="inline w-full mt-4">
      <button
        onClick={onClick}
        className={`w-full h-[60px] flex items-center justify-center rounded-3xl font-bold ${"bg-blue-500  text-white"}`}
      >
        {text}
      </button>
    </FadeInWrapper>
  );
};
